<template>
    <div class="nomination-scheduler">
      <ContentHeader :name="$route.name"></ContentHeader>
      <transition name="grow">
        <div v-if="contentReady">
          <div class="row">
            <h4 class="text-black-50">{{ contentLoadError }}</h4>
          </div>
          <br>
          <div class="row table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nominee</th>
                  <th>Nominator</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(noms, index) in olderNomination">
                  <th scope="row" v-if="noms.equity_accept_reject[0] === 'Pending'">{{ noms.id }}</th>
                  <td class="breakall" v-if="noms.equity_accept_reject[0] === 'Pending'">{{ noms.equity_nominee_name[0] }}</td>
                  <td class="breakall" v-if="noms.equity_accept_reject[0] === 'Pending'">{{ noms._embedded.author[0].name }}</td>
                  <td class="breakall" v-if="noms.equity_accept_reject[0] === 'Pending'">{{ noms.date }}</td>
                  <td class="breakall" v-if="noms.equity_accept_reject[0] === 'Pending'">{{ noms.equity_accept_reject[0] }}</td>
                  <td class="breakall" v-if="noms.equity_accept_reject[0] === 'Pending'"><input class="btn btn-primary" type="button" value="Notify" @click="sendNotification(noms)"/></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import Loading from '@/components/Loading'
import NominationNotification from '@/helpers/NominationNotification.js'

export default {
  components: {
    ContentHeader,
    Loading
  },
  data () {
    return {
      contentReady: true,
      contentLoadError: '',
      notifiedList: [],
      olderNomination: [],
      postNomination: [],
      startWeeksVal: '-- Select --',
      startWeeks: [ '4 day ago', '1 week ago', '2 week ago', '3 week ago' ],
      startMonthsVal: '-- Select --',
      startMonths: [ '3 month ago', '6 Month ago', '12 Month ago' ],
      validationFromCLass: 'form-control',
      validationToCLass: 'form-control',
      postID: ''
    }
  },
  created () {
    this.loadOlderNotification()
  },
  methods: {
    sendNotification: function (nominationDetails) {
      console.log('index val -> ', nominationDetails)
      let emailBody = ''
      var tempEmail = []
      if (nominationDetails.id) {
        emailBody = NominationNotification.equitynominationBodyforNominee({
          reviewLink: 'https://thinktank.multichoice.com/#/login/equity-review+' + nominationDetails.id,
        })
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: nominationDetails.equity_nominee_email[0],
            subject: 'Reminder - Your Nomination as Employment Equity Forum Representative',
            message: emailBody
          },
          json: true
        }
        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    },
    loadOlderNotification: function () {
      WordpressRestAPI.getViewContent('employment_equity?_embed=true&custom_per_page=500')
        .then(response => {
          if (response.data !== false) {
            console.log('getOLD-> ', response.data)
            this.olderNomination = response.data
            // this.loadOlderNomination(response.data)
          } else {
            this.contentLoadError = 'Oops! We had a problem fetching nomination list. Please try again later.'
          }
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
          this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
        })
    }   
  }
}
</script>
<style scoped>
td.breakall {word-break: break-all;}
</style>


// WEBPACK FOOTER //
// src/components/routes/EEReminder.vue